import React, { useState, useEffect } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import * as Yup from "yup";
import moment, { duration } from "moment";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useFormik, Form, FormikProvider, Field, FieldArray } from "formik";
import {
  DatePickerCustom,
  SelectCustomLable,
  SelectMultipleCustom,
  Texteditor,
  UploadImage,
} from ".";

import { Input, Select as SelectAnt, Modal } from "antd";
import { apiURL } from "../../utils/config";
import { createCourses, updateCourses } from "../../appRedux/actions/courses";
import { getPlatformsList } from "../../appRedux/actions/platforms";
import { getTagsList } from "../../appRedux/actions/tags";

import { PlaceHolder } from "../../Routes/ImagePath";
import { currencyConverter, currencyConverterForm } from "../../utils/currency";
import { LANGUAGE_OPTIONS, normalizeLanguageCode } from "../../utils/languages";
import MetaTagForm from "./MetaTagForm";
import MetaTag from "./MetaTag";


const { Option } = SelectAnt;
const INITIAL_STATE = {
  title: "",
  headlines: "",
  description: "",
  out_come: "",
  category: "",
  affiliation: {
    _id: "",
    name: "",
    imageUrl: "",
  },
  courseType: "",
  duration: "",
  duration_per_week: "",
  merchant: "",
  websiteUrl: "",
  level: "",
  skills: [],
  tags: [],
  mode: "",
  price: "",
  rating: 4.5,
  review_count: 20,
  students_enrolled: 0,
  price_detail: {
    price: 0,
    symbol: "₹",
    currency: "INR",
    certificate: true,
  },
  image_url: "",
  meta: [
    {
      name: "title",
      property: "",
      content: "",
      placeholder: "Page title here",
    },
    {
      name: "description",
      property: "",
      content: "",
      placeholder: "Page description here",
    },
    {
      name: "",
      property: "og:title",
      content: "",
      placeholder: "Open Graph Title",
    },
    {
      name: "",
      property: "og:description",
      content: "",
      placeholder: "Open Graph Description",
    },
  ],
  // imageUrl:
  //   "https://prod-discovery.edx-cdn.org/cdn-cgi/image/width=auto,height=auto,quality=75,format=webp/media/course/image/a2139fb0-ef8f-4c5c-8ff3-fcddc7f3c827-22730e17f471.small.jpg",
};
function FormView(props) {
  const { courseInfo, courseFilters, currencyList, queryInfo } = useSelector(
    (state) => ({
      courseInfo: state.courses.courseInfo,
      courseFilters: state.courses.courseFilters,
      queryInfo: state.courses.queryInfo,
      currencyList: state.common.currencyList,
    })
  );

  const currencyData = useSelector((state) => state.common.currencyData);
  const selectedCurrency = useSelector(
    (state) => state.common.selectedCurrency
  );
  const [oneYears, setOneYears] = useState(true);
  const dbPlatformList = useSelector((state) => state.platforms.platformList || []);
  const tagsList = useSelector((state) => state.tags?.tagsList || []);

  const [categoriesList, setCategoriesList] = useState(courseFilters.category);
  const [modeList, setModeList] = useState(courseFilters.mode);
  const [platformList, setPlatformList] = useState(courseFilters.platform);
  const [affiliationList, setAffiliationList] = useState(
    courseFilters.affiliation
  );
  const [courseTypeList, setCourseTypeList] = useState(
    courseFilters.courseType
  );
  const [languageList, setLanguageList] = useState(courseFilters.language);
  const [ratingList, setRatingList] = useState(courseFilters.rating);
  const [levelList, setLevelList] = useState(courseFilters.level);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPlatformsList({ page: 1, size: 100 }));
    dispatch(getTagsList());
  }, [dispatch]);

  useEffect(() => {
    if (dbPlatformList && dbPlatformList.length > 0) {
      setPlatformList(dbPlatformList);
    } else {
      setPlatformList(courseFilters.platform);
    }
  }, [dbPlatformList, courseFilters.platform]);

  useEffect(() => {
    setCategoriesList(courseFilters.category);
    setModeList(courseFilters.mode);
    setAffiliationList(courseFilters.affiliation);
    setCourseTypeList(courseFilters.courseType);
    setLanguageList(courseFilters.language);
    setRatingList(courseFilters.rating);
    setLevelList(courseFilters.level);

  }, [courseFilters]);
  // const handleDateChange1 = (date) => {
  //   setSelectedDate1(date);
  // };
  const { isUpdate, reJoin } = props;
  const [formInfo, setFormInfo] = useState(INITIAL_STATE);
  const navigate = useNavigate();

  useEffect(() => {
    // dispatch(hideMessage());
    if (isUpdate && courseInfo && courseInfo._id) {
      const affiliationInfo =
        courseInfo.affiliation && courseInfo.affiliation._id && Array.isArray(affiliationList)
          ? affiliationList.find((info) => info._id === courseInfo.affiliation._id)
          : null;
      let meta = courseInfo.meta
        ? courseInfo.meta.map((tag) => ({
            name: tag.name || "",
            property: tag.property || "",
            content: tag.content || "",
          })).filter(tag => tag.name || tag.property)
        : [...INITIAL_STATE.meta];
        
      if (courseInfo.meta) {
        // Ensure default tags are present if missing
        INITIAL_STATE.meta.forEach(defaultTag => {
          const exists = meta.find(t => 
            (defaultTag.name && t.name === defaultTag.name) || 
            (defaultTag.property && t.property === defaultTag.property)
          );
          if (!exists) {
            meta.push({ ...defaultTag });
          }
        });
      }
      console.log({ affiliationInfo });
      setFormInfo({
        ...INITIAL_STATE,
        ...courseInfo,
        courseType: courseInfo.course_type && courseInfo.course_type._id,
        websiteUrl: courseInfo.website_url,
        category: courseInfo.category && courseInfo.category._id,
        mode: courseInfo.mode && courseInfo.mode._id,
        level: courseInfo.level && courseInfo.level._id,
        skills: Array.isArray(courseInfo.skills)
          ? courseInfo.skills.map((skill) =>
              typeof skill === "string" ? skill : skill._id
            )
          : [],
        tags: Array.isArray(courseInfo.tags)
          ? courseInfo.tags.map((tag) =>
              typeof tag === "string" ? tag : tag._id
            )
          : [],
        affiliation: courseInfo.affiliation
          ? {
              ...courseInfo.affiliation,
              imageUrl:
                courseInfo.affiliation.imageUrl
                  ? courseInfo.affiliation.imageUrl
                  : affiliationInfo && affiliationInfo.imageUrl
                  ? affiliationInfo.imageUrl
                  : "",
            }
          : { ...INITIAL_STATE.affiliation },
        price_detail: {
          ...courseInfo.price_detail,
          price:
            courseInfo.price_detail && courseInfo.price_detail.price > 0
              ? courseInfo.price_detail.price
              : courseInfo.price,
        },
        language: normalizeLanguageCode(courseInfo.language),
        students_enrolled: courseInfo.students_enrolled !== undefined && courseInfo.students_enrolled !== null ? courseInfo.students_enrolled : 0,
        meta,
      });
    } else {
      //console.log("");
      setFormInfo({
        ...INITIAL_STATE,
      });
    }
  }, [isUpdate, courseInfo]);

  const FormSchema = Yup.object().shape({
    title: Yup.string().trim().required("Course title is required."),
    websiteUrl: Yup.string().trim().required("Web site url is required."),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: formInfo,
    validationSchema: FormSchema,
    onSubmit: (data) => {
      console.log({ data });

      const info = {
        symbol: "₹",
        currency: "INR",
      };

      let websiteUrl = data.websiteUrl || "";
      if (websiteUrl && !/^https?:\/\//i.test(websiteUrl)) {
        websiteUrl = "https://" + websiteUrl;
      }

      let priceDetail = data.price_detail || { price: 0, symbol: "₹", currency: "INR" };
      let price = priceDetail?.price || 0;
      if (priceDetail.currency && priceDetail.currency !== "INR") {
        price = currencyConverterForm(price, info, currencyData);
        priceDetail = { ...priceDetail, price, symbol: "₹", currency: "INR" };
      }
      const meta = (data.meta || [])
        .map(({ name, property, content }) => {
          const cleanedItem = { content };
          if (name) cleanedItem.name = name;
          if (property) cleanedItem.property = property;
          return cleanedItem;
        })
        .filter((item) => item.name || item.property);

      if (isUpdate && courseInfo && courseInfo._id) {
        dispatch(
          updateCourses(
            {
              ...data,
              courseId: courseInfo._id,
              course_type: data.courseType,
              website_url: websiteUrl,
              price: price,
              price_detail: priceDetail,
              meta,
              _id: undefined,
            },
            queryInfo
          )
        )
          .then(() => {
            navigate("/course/list");
          })
          .catch((err) => {
            console.error("Update course error:", err);
            Modal.error({
              title: "Failed to Update Course",
              content:
                err?.userMessage || err?.message || "An error occurred while saving the course. Please check your data and try again.",
            });
          });
      } else {
        dispatch(
          createCourses({
            ...data,
            course_type: data.courseType,
            website_url: websiteUrl,
            price: price,
            price_detail: priceDetail,
            meta,
          })
        )
          .then(() => {
            navigate("/course/list");
          })
          .catch((err) => {
            console.error("Create course error:", err);
            Modal.error({
              title: "Failed to Create Course",
              content:
                err?.userMessage || err?.message || "An error occurred while saving the course. Please check your data and try again.",
            });
          });
      }
    },
  });

  const getFlattenedErrors = (obj, prefix = "") => {
    let result = {};
    if (!obj || typeof obj !== "object") return result;

    Object.keys(obj).forEach((key) => {
      const val = obj[key];
      const newKey = prefix ? `${prefix}.${key}` : key;
      if (val && typeof val === "string" && val.trim() !== "") {
        result[newKey] = val;
      } else if (val && typeof val === "object" && !Array.isArray(val)) {
        Object.assign(result, getFlattenedErrors(val, newKey));
      } else if (Array.isArray(val)) {
        val.forEach((item, idx) => {
          if (item && typeof item === "object") {
            Object.assign(result, getFlattenedErrors(item, `${newKey}[${idx}]`));
          } else if (item && typeof item === "string" && item.trim() !== "") {
            result[`${newKey}[${idx}]`] = item;
          }
        });
      }
    });
    return result;
  };

  const handleSaveClick = async (e) => {
    if (e && e.preventDefault) e.preventDefault();

    formik.setTouched({
      title: true,
      websiteUrl: true,
    });

    const rawErrors = await formik.validateForm();
    const activeErrors = getFlattenedErrors(rawErrors);
    console.log({ rawErrors, activeErrors });

    if (Object.keys(activeErrors).length > 0) {
      const errorList = Object.entries(activeErrors).map(([field, err]) => {
        const fieldName =
          field === "websiteUrl"
            ? "WebUrl"
            : field === "title"
            ? "Course Title"
            : field;
        return `${fieldName}: ${err}`;
      });

      Modal.error({
        title: "Please Complete Required Fields",
        content: (
          <div>
            <p>The following fields need your attention:</p>
            <ul>
              {errorList.map((err, idx) => (
                <li key={idx}>{err}</li>
              ))}
            </ul>
          </div>
        ),
      });
    } else {
      formik.handleSubmit();
    }
  };

  const {
    errors,
    touched,
    values,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
    getFieldProps,
    setFieldValue,
  } = formik;

  return (
    <FormikProvider value={formik}>
      <Form
        id="contactForm"
        autoComplete="off"
        noValidate
        onSubmit={handleSubmit}
        className="signin-form"
      >
        {/* Top Action Header */}
        <div className="top-action-header d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-2">
            <i className="fa fa-book-open text-primary fs-5"></i>
            <h5 className="m-0 font-weight-bold text-dark">
              {isUpdate && courseInfo && courseInfo._id ? "Edit Course Details" : "Create New Course"}
            </h5>
          </div>
          <div className="d-flex align-items-center gap-2">
            <button type="button" className="btn btn-primary px-4 py-2 font-weight-bold" onClick={handleSaveClick}>
              <i className="fa fa-save me-2"></i>
              {isUpdate && courseInfo && courseInfo._id ? "Update Course" : "Save Course"}
            </button>
          </div>
        </div>

        {/* Section 1: Source & Identity */}
        <div className="course-form-card">
          <div className="card-section-header">
            <div className="card-section-icon"><i className="fa fa-globe"></i></div>
            <h6 className="card-section-title">Course Identity & Source</h6>
          </div>
          <div className="row g-3">
            <div className="col-md-12">
              <div className="input-block mb-2">
                <label className="col-form-label font-weight-bold">
                  WebUrl <span className="text-danger">*</span>
                </label>
                <div className="input-group">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter course URL..."
                    {...getFieldProps("websiteUrl")}
                  />
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={() => {
                      Modal.info({
                        title: "Feature Coming Soon",
                        content: "Live course crawling and automatic data extraction is under development and will be available soon!",
                        centered: true,
                      });
                    }}
                  >
                    <i className="fa fa-spider me-1"></i> Live Crawl
                  </button>
                </div>
                <p className="error-msg text-danger">
                  {(touched.websiteUrl || formik.submitCount > 0) && errors.websiteUrl}
                </p>
              </div>
            </div>

            <div className="col-md-8">
              <div className="input-block mb-2">
                <label className="col-form-label font-weight-bold">
                  Course Title <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter full course title..."
                  {...getFieldProps("title")}
                />
                <p className="error-msg text-danger">
                  {(touched.title || formik.submitCount > 0) && errors.title}
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="input-block mb-2">
                <label className="col-form-label font-weight-bold">Platform / Merchant</label>
                <SelectCustomLable
                  className="text-capitalize"
                  placeholder="Select Platform"
                  showSearch={true}
                  options={platformList.map((option) => ({
                    _id: option.code,
                    name: option.name,
                  }))}
                  value={values.merchant}
                  onChange={(value) => {
                    if (value !== "select") {
                      setFieldValue("merchant", value);
                    }
                  }}
                  onBlur={() => {
                    handleBlur({ target: { name: "merchant" } });
                  }}
                />
                <p className="error-msg text-danger">
                  {touched.merchant && errors.merchant}
                </p>
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group mb-2">
                <label className="col-form-label font-weight-bold">Headlines / Short Summary</label>
                <textarea
                  className="form-control"
                  rows={2}
                  type="text"
                  placeholder="Brief catchy headline or tagline..."
                  {...getFieldProps("headlines")}
                />
                <p className="error-msg text-danger">
                  {touched.headlines && errors.headlines}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Section 2: Classification, Pricing & Logistics Grid */}
        <div className="course-form-card">
          <div className="card-section-header">
            <div className="card-section-icon"><i className="fa fa-th-large"></i></div>
            <h6 className="card-section-title">Course Taxonomy, Pricing & Logistics</h6>
          </div>
          <div className="row g-3">
            <div className="col-md-3 col-sm-6">
              <div className="input-block mb-2">
                <label className="col-form-label font-weight-bold">Category</label>
                <SelectCustomLable
                  className="text-capitalize"
                  placeholder="Select Category"
                  showSearch={true}
                  options={categoriesList.map((option) => ({
                    _id: option._id,
                    name: option.name,
                  }))}
                  value={values.category}
                  onChange={(value) => {
                    if (value !== "select") {
                      setFieldValue("category", value);
                    }
                  }}
                  onBlur={() => {
                    handleBlur({ target: { name: "category" } });
                  }}
                />
              </div>
            </div>

            <div className="col-md-3 col-sm-6">
              <div className="input-block mb-2">
                <label className="col-form-label font-weight-bold">Tags</label>
                <SelectMultipleCustom
                  placeholder="Select Tags"
                  showSearch={true}
                  options={tagsList.map((t) => ({ _id: t._id, name: t.name }))}
                  value={values.tags}
                  onChange={(value) => {
                    setFieldValue("tags", value);
                  }}
                  onBlur={() => {
                    handleBlur({ target: { name: "tags" } });
                  }}
                />
              </div>
            </div>

            <div className="col-md-3 col-sm-6">
              <div className="input-block mb-2">
                <label className="col-form-label font-weight-bold">Course Type</label>
                <SelectCustomLable
                  className="text-capitalize"
                  placeholder="Select Course Type"
                  showSearch={true}
                  options={courseTypeList.map((option) => ({
                    _id: option._id,
                    name: option.name,
                  }))}
                  value={values.courseType}
                  onChange={(value) => {
                    if (value !== "select") {
                      setFieldValue("courseType", value);
                    }
                  }}
                  onBlur={() => {
                    handleBlur({ target: { name: "courseType" } });
                  }}
                />
              </div>
            </div>

            <div className="col-md-3 col-sm-6">
              <div className="input-block mb-2">
                <label className="col-form-label font-weight-bold">Course Level</label>
                <SelectCustomLable
                  className="text-capitalize"
                  placeholder="Select Level"
                  showSearch={true}
                  options={levelList
                    .filter((info) => info.name && info.name !== "")
                    .map((option) => ({
                      _id: option._id,
                      name: option.name,
                    }))}
                  value={values.level}
                  onChange={(value) => {
                    if (value !== "select") {
                      setFieldValue("level", value);
                    }
                  }}
                  onBlur={() => {
                    handleBlur({ target: { name: "level" } });
                  }}
                />
              </div>
            </div>

            <div className="col-md-3 col-sm-6">
              <div className="input-block mb-2">
                <label className="col-form-label font-weight-bold">Mode</label>
                <SelectCustomLable
                  className="text-capitalize"
                  placeholder="Select Mode"
                  showSearch={true}
                  options={modeList.map((option) => ({
                    _id: option._id,
                    name: option.name,
                  }))}
                  value={values.mode}
                  onChange={(value) => {
                    if (value !== "select") {
                      setFieldValue("mode", value);
                    }
                  }}
                  onBlur={() => {
                    handleBlur({ target: { name: "mode" } });
                  }}
                />
              </div>
            </div>

            <div className="col-md-3 col-sm-6">
              <div className="input-block mb-2">
                <label className="col-form-label font-weight-bold">Language</label>
                <SelectCustomLable
                  className="text-capitalize"
                  placeholder="Select Language"
                  showSearch={true}
                  options={LANGUAGE_OPTIONS}
                  value={values.language}
                  onChange={(value) => {
                    if (value !== "select") {
                      setFieldValue("language", value);
                    }
                  }}
                  onBlur={() => {
                    handleBlur({ target: { name: "language" } });
                  }}
                />
              </div>
            </div>

            <div className="col-md-3 col-sm-6">
              <div className="form-group mb-2">
                <label className="col-form-label font-weight-bold">Total Duration</label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="e.g. 10 hours"
                  {...getFieldProps("duration")}
                />
              </div>
            </div>

            <div className="col-md-3 col-sm-6">
              <div className="form-group mb-2">
                <label className="col-form-label font-weight-bold">Duration Per Week</label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="e.g. 2 hrs/week"
                  {...getFieldProps("duration_per_week")}
                />
              </div>
            </div>

            <div className="col-md-3 col-sm-6">
              <div className="row g-2">
                <div className="col-6">
                  <div className="form-group mb-2">
                    <label className="col-form-label font-weight-bold">Price</label>
                    <input
                      className="form-control"
                      type="number"
                      step="any"
                      placeholder="0.00"
                      {...getFieldProps("price_detail.price")}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group mb-2">
                    <label className="col-form-label font-weight-bold">Currency</label>
                    <SelectCustomLable
                      className="text-capitalize"
                      placeholder="Select Currency"
                      showSearch={true}
                      options={currencyList.map((option) => ({
                        _id: option.currency,
                        name: option.currency,
                      }))}
                      value={values.price_detail.currency}
                      onChange={(value) => {
                        if (value !== "select") {
                          const info = currencyList.find(
                            (curr) => curr.currency === value
                          );
                          let priceValue = values?.price_detail?.price || 0;
                          const price = currencyConverterForm(
                            priceValue,
                            info,
                            currencyData
                          );
                          setFieldValue("price_detail.price", price);
                          setFieldValue("price_detail.currency", value);
                          setFieldValue("price_detail.symbol", info.symbol);
                        }
                      }}
                      onBlur={() => {
                        handleBlur({
                          target: { name: "price_detail.currency" },
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4 col-sm-4">
              <div className="form-group mb-2">
                <label className="col-form-label font-weight-bold">Rating (0.0 - 5.0)</label>
                <input
                  className="form-control"
                  type="number"
                  step="0.1"
                  min="0"
                  max="5"
                  placeholder="4.5"
                  {...getFieldProps("rating")}
                />
              </div>
            </div>

            <div className="col-md-4 col-sm-4">
              <div className="form-group mb-2">
                <label className="col-form-label font-weight-bold">Total Reviews</label>
                <input
                  className="form-control"
                  type="number"
                  min="0"
                  placeholder="e.g. 1250"
                  {...getFieldProps("review_count")}
                />
              </div>
            </div>

            <div className="col-md-4 col-sm-4">
              <div className="form-group mb-2">
                <label className="col-form-label font-weight-bold">Students Enrolled</label>
                <input
                  className="form-control"
                  type="number"
                  min="0"
                  placeholder="e.g. 45000"
                  {...getFieldProps("students_enrolled")}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Section 3: Detailed Content */}
        <div className="course-form-card">
          <div className="card-section-header">
            <div className="card-section-icon"><i className="fa fa-align-left"></i></div>
            <h6 className="card-section-title">Course Description & Outcomes</h6>
          </div>
          <div className="row g-3">
            <div className="col-md-12">
              <div className="form-group mb-3">
                <label className="col-form-label font-weight-bold">Description</label>
                <Texteditor
                  description={values.description}
                  onChange={(value) => setFieldValue("description", value)}
                  height="350px"
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group mb-3">
                <label className="col-form-label font-weight-bold">What You Will Learn</label>
                <Texteditor
                  description={values.out_come}
                  onChange={(value) => setFieldValue("out_come", value)}
                  height="350px"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Section 4: SEO & Metadata */}
        <div className="course-form-card">
          <div className="card-section-header">
            <div className="card-section-icon"><i className="fa fa-search"></i></div>
            <h6 className="card-section-title">SEO & Metadata</h6>
          </div>
          <MetaTag {...{ values, errors, touched, setFieldValue }} courseId={isUpdate && courseInfo ? courseInfo._id : null} />
        </div>

        {/* Section 5: Media & Affiliation */}
        <div className="course-form-card">
          <div className="card-section-header">
            <div className="card-section-icon"><i className="fa fa-image"></i></div>
            <h6 className="card-section-title">Media & Affiliation</h6>
          </div>
          <div className="row g-4 align-items-start">
            {/* Left Side: Course Cover Image */}
            <div className="col-md-6">
              <div className="row g-3">
                <div className="col-12">
                  <div className="form-group mb-2">
                    <label className="col-form-label font-weight-bold">Course Image URL</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="https://img-c.udemycdn.com/..."
                      {...getFieldProps("image_url")}
                    />
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group mb-0">
                    <label className="col-form-label font-weight-bold">Course Cover Image (Upload or Live Preview)</label>
                    <div className="mt-1">
                      <UploadImage
                        {...{
                          fileList:
                            values.image_url && values.image_url !== ""
                              ? [
                                  {
                                    uid: "-1",
                                    name: "image.png",
                                    status: "done",
                                    url: values.image_url,
                                  },
                                ]
                              : [],
                          setFileList: (list) => {
                            var newList = [];
                            for (let i = 0; i < list.length; i++) {
                              let listInfo = list[i];
                              if (
                                listInfo.status === "done" &&
                                listInfo.response &&
                                listInfo.response.status === true
                              ) {
                                newList.push({
                                  name: listInfo.name,
                                  status: listInfo.status,
                                  size: listInfo.size,
                                  type: listInfo.type,
                                  uid: listInfo.uid,
                                  url: listInfo.response.results,
                                });
                              } else {
                                newList.push(listInfo);
                              }
                            }
                            setFieldValue(
                              "image_url",
                              newList.length && newList[0]["url"] ? newList[0]["url"] : ""
                            );
                          },
                          image:
                            values.image_url !== "" ? values.image_url : null,
                          setImageUrl: (url) => {
                            setFieldValue("image_url", url);
                          },
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side: Affiliation Partner & Badge */}
            <div className="col-md-6">
              <div className="row g-4">
                <div className="col-12">
                  <div className="input-block mb-0">
                    <label className="col-form-label font-weight-bold">Affiliation Partner</label>
                    <SelectCustomLable
                      className="text-capitalize"
                      placeholder="Select Affiliation"
                      showSearch={true}
                      options={affiliationList}
                      value={values.affiliation ? values.affiliation.name : ""}
                      onChange={(value) => {
                        if (value !== "select") {
                          const info = affiliationList.find(
                            (info) => info._id === value
                          );
                          setFieldValue("affiliation._id", value);
                          setFieldValue("affiliation.name", info.name);
                          setFieldValue("affiliation.imageUrl", info.imageUrl);
                        }
                      }}
                      onBlur={() => {
                        handleBlur({ target: { name: "affiliation._id" } });
                      }}
                    />
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group mb-0">
                    <label className="col-form-label font-weight-bold">Affiliation Badge Preview</label>
                    <div
                      style={{
                        width: "180px",
                        height: "70px",
                        border: "1px solid #e5e7eb",
                        borderRadius: "8px",
                        padding: "8px 16px",
                        background: "#ffffff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
                      }}
                    >
                      <img
                        src={
                          values.affiliation && values.affiliation.imageUrl
                            ? values.affiliation.imageUrl
                            : PlaceHolder
                        }
                        alt={
                          values.affiliation && values.affiliation.name
                            ? values.affiliation.name
                            : "Affiliation Badge"
                        }
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "contain",
                          display: "block"
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = PlaceHolder;
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="submit-section mb-5 d-flex justify-content-end">
          <button type="button" className="btn btn-primary submit-btn px-5 py-2" onClick={handleSaveClick}>
            <i className="fa fa-save me-2"></i>
            {isUpdate && courseInfo && courseInfo._id ? "Update Course" : "Save Course"}
          </button>
        </div>
      </Form>
    </FormikProvider>
  );
}

export default FormView;
